import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_3mrkeupyq4: FaireCollectionEntity = {
  token: "pbc_3mrkeupyq4",
  type: "collection",
  name: "mini notecards",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e8f2fd5d9cc3bbcad49bcf4a6fab4b3fd3ef4b021583ee5272a21d571ea6e179.jpeg",
  itemCount: 119,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:21.811Z",
    importedBy: "entity-db-import-collections",
  },
};
